module.exports = __webpack_public_path__ + "34eb5f592af7e3948f4dd6a7593902e8.svg";